import BasePage from '@/v2/views/components/BasePage'
import util from '../utils'
import { Notification } from 'element-ui'
import cityMultipleReport from './cityReport'

const ExamSingle = (r) => require(['@/pages/exam/single/index'], r) // 单科考试列表
const RecycleBin = (r) => require(['@/v2/views/exam/recycle-bin'], r) // 单科考试回收站列表
const ExamSingleCreate = (r) => require(['@/pages/exam/single/create'], r) // 创建单科考试
const ExamSingleMultipleCreate = (r) => require(['@/pages/exam/single/multiple'], r) // 创建单科考试
const ExamSingleOldAnswer = (r) => require(['@/pages/exam/single/answer'], r) // 标准答案
const ExamSingleAnswer = (r) => require(['@/v2/views/exam/single/answer/index'], r) // 标准答案
const ExamSingleScanPaper = (r) => require(['@/pages/exam/single/scanPaper'], r) // 识别
const ExamSingleScanPaperSummary = (r) => require(['@/pages/exam/single/scanPaperSummary'], r) // 识别汇总
const ExamSingleQuestion = (r) => require(['@/pages/exam/single/question'], r) // 疑问项
const ExamSingleImport = (r) => require(['@/pages/exam/single/import'], r) // 导入考试
const ExamCreateAnswerSheet = (r) => require(['@/pages/exam/single/create_answer_sheet'], r) // 创建与编辑考试( 在线制卡 )

// 区域单科报告
const ExamSingleReportLayout = (r) => require(['@/pages/exam/single/report/layout'], r)
const ExamSingleReportBasic = (r) => require(['@/pages/exam/single/report/basic'], r)
const ExamSingleReportBasicCity = (r) => require(['@/pages/exam/single/report/basicCity'], r)
const ExamSingleReportAbility = (r) => require(['@/pages/exam/single/report/ability'], r)
const ExamSingleReportComment = (r) => require(['@/pages/exam/single/report/comment'], r)
const ExamSingleReportCommentCity = (r) => require(['@/pages/exam/single/report/commentCity'], r)
const ExamSingleReportCommentEdit = (r) => require(['@/pages/exam/single/report/commentEdit'], r)
const ExamSingleReportCustomLayout = (r) => require(['@/pages/exam/single/report/customLayout'], r)
const ExamSingleReportCustomGroup = (r) => require(['@/pages/exam/single/report/customGroup'], r)
const ExamSingleReportCustomContrast = (r) => require(['@/pages/exam/single/report/customContrast'], r)
const ExamSingleReportCustomKnowModel = (r) => require(['@/pages/exam/single/report/customKnowModel'], r)
const ExamSingleReportTranscript = (r) => require(['@/pages/exam/single/report/transcript'], r)
const ExamSingleReportClassBasic = (r) => require(['@/pages/exam/single/report/classBasic'], r)
const ExamSingleReportClassComment = (r) => require(['@/pages/exam/single/report/classComment'], r)
const ExamSingleReportAreaBasic = (r) => require(['@/pages/exam/single/report/areaBasic'], r)
const ExamSingleReportAreaComment = (r) => require(['@/pages/exam/single/report/areaComment'], r)
const ExamSingleReportAreaAbility = (r) => require(['@/pages/exam/single/report/areaAbility'], r)
const ExamSingleReportAreaTranscript = (r) => require(['@/pages/exam/single/report/areaTranscript'], r)
const ExamSingleReportRank = (r) => require(['@/pages/exam/single/report/rank'], r)
const ExamSingleReportPaperQuality = (r) => require(['@/v2/views/report/paper-quality'], r)
// 多科考试
const ExamMultiple = r => require(['@/pages/exam/multiple/index'], r)
const ExamMultipleCreateNew = r => require(['@/pages/exam/multiple/createNew'], r)
const ExamMultipleReportLayout = r => require(['@/pages/exam/multiple/report/layout'], r)
const ExamMultipleReportBasic = r => require(['@/pages/exam/multiple/report/basic'], r)
const ExamMultipleReportComment = r => require(['@/pages/exam/multiple/report/comment'], r)
const ExamMultipleReportAbility = r => require(['@/pages/exam/multiple/report/ability'], r)
const ExamMultipleReportTranscript = r => require(['@/pages/exam/multiple/report/transcript'], r)
const multipleStudentSubmit = r => require(['@/pages/exam/multiple/student_submit'], r) // 考试列表
// 区域报告，内容来自市级多科报告
const CityExamMultipleReportSchoolLevel = (r) => require(['@/pages/exam/multiple/report_city/school/level'], r)
const CityExamMultipleReportSchoolRank = (r) => require(['@/pages/exam/multiple/report_city/school/rank'], r)

// 网络阅卷
const ExamMarking = (r) => require(['@/pages/exam/marking/index'], r) // 网络阅卷列表
const ExamMarkingReadPaper = (r) => require(['@/v2/views/network/read'], r)
const ExamMarkingPaperReview = r => require(['@/v2/views/network/paperReview'], r)
const ExamMarkingSettingNew = r => require(['@/v2/views/network/setting'], r)
const ExamMarkingCheckPaper = (r) => require(['@/v2/views/network/monitor/checkPaper'], r)

const ExamMarkingError = (r) => require(['@/pages/exam/marking/error'], r)
const ExamMarkingReadMonitor = (r) => require(['@/pages/exam/marking/readMonitor'], r)
const ExamMarkingDataRegionProgress = (r) => require(['@/v2/views/network/monitor'], r) //区域监控
// 旧版监控
const ExamMarkingData = r => require(['@/pages/exam/marking/data/layout'], r)
const ExamMarkingDataProgress = r => require(['@/pages/exam/marking/data/progress'], r)
const ExamMarkingDataSpread = r => require(['@/pages/exam/marking/data/spread'], r)
const ExamMarkingDataQuality = r => require(['@/pages/exam/marking/data/quality'], r)
const ExamMarkingDataMonitor = r => require(['@/pages/exam/marking/data/monitor'], r)

// 考试审核
const ExamAudit = (r) => require(['@/pages/exam/single/audit'], r)

//新高考
const XGK = (r) => require(['@/pages/exam/xgk/index'], r)

import GaoKao from './gaokao'
import v2 from "@/v2/router/index"; // 新版页面

function requireAuth (to, from, next) {
  if (!util.isLogin()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (to.meta.auth && !util.isAuth(to.meta.auth)) {
      const info = {
        title: "禁止访问！",
        message: "对不起，您没有本页访问权限",
        type: "error"
      }
      Notification(info);
    } else {
      next()
    }
  }
}
function isNotRequireAuth (to, from, next) {
  next()
}

export const exam = {
  path: '/region/exam',
  component: BasePage,
  beforeEnter: requireAuth,
  meta: { auth: 'Region-Exam' },
  children: [
    ...cityMultipleReport,
    {
      path: '/region/exam/single/audit',
      name: 'exam-audit',
      component: ExamAudit
    },
    {
      path: '/region/exam/single/import',
      name: 'exam-import',
      component: ExamSingleImport
    },
    {
      path: '/region/exam/single/answer-old/:id',
      meta: { auth: 'Region-Exam-Single' },
      name: 'exam-answer-old',
      component: ExamSingleOldAnswer
    },
    {
      path: '/region/exam/single/answer/:id',
      meta: { auth: 'Region-Exam-Single' },
      name: 'exam-answer',
      component: ExamSingleAnswer
    },
    {
      path: '/region/exam/single/scanpaper/:id',
      meta: { auth: 'Region-Exam-Single' },
      name: 'exam-scanpaper',
      component: ExamSingleScanPaper
    },
    {
      path: '/region/exam/single/scanpaperSummary/:id',
      meta: { auth: 'Region-Exam-Single' },
      name: 'exam-scanpaper-summary',
      component: ExamSingleScanPaperSummary
    },
    {
      path: '/region/exam/single/question/:id',
      meta: { auth: 'Region-Exam-Single' },
      name: 'exam-question',
      component: ExamSingleQuestion
    },
    {
      path: '/region/exam/single_old',
      component: ExamSingle,
      meta: { auth: 'Region-Exam-Single', keepAlive: true }
    },
    {
      path: '/region/exam/single/recycle',
      name: 'recycle-bin',
      component: RecycleBin,
      meta: { auth: 'Region-Exam-Single' }
    },
    {
      path: '/region/exam/single/create_old',
      meta: { auth: 'Region-Exam-Single' },
      component: ExamSingleCreate
    },
    {
      path: '/region/exam/single/multiple',
      meta: { auth: 'Region-Exam-Single' },
      component: ExamSingleMultipleCreate
    },
    {
      path: '/region/exam/single/edit_old/:id',
      meta: { auth: 'Region-Exam-Single' },
      name: 'exam-edit',
      component: ExamSingleCreate
    },
    {
      path: '/region/exam/single/create_answer_sheet',
      meta: { auth: 'Region-Exam-Single' },
      component: ExamCreateAnswerSheet
    },
    {
      path: '/region/exam/card/list',
      name: 'card-list',
      component: (r) => require(['@/pages/card/list'], r)
    },
    {
      path: '/region/exam/multiple',
      meta: { auth: 'Region-Exam-Multiple', keepAlive: true, parentPath: '/region/exam/single' },
      component: ExamMultiple
    },
    {
      path: '/region/exam/multiple/create',
      meta: { auth: 'Region-Exam-Multiple', parentPath: '/region/exam/single' },
      component: ExamMultipleCreateNew
    },
    {
      path: '/region/exam/multiple/edit/:id',
      name: 'exam-multiple-edit',
      meta: { auth: 'Region-Exam-Multiple', parentPath: '/region/exam/single' },
      component: ExamMultipleCreateNew
    },
    {
      path: "/region/exam/multiple/student_submit",
      component: multipleStudentSubmit,
      meta: { auth: "Region-Exam-Multiple", keepAlive: true, parentPath: '/region/exam/single' }
    },

    {
      path: '/region/exam/xgk/index',
      name: 'exam-xgk',
      meta: { auth: 'Region-Exam-XGK' },
      component: XGK
    },

    ...GaoKao,
    // 多科报告
    {
      path: '/region/exam/multiple/report',
      component: ExamMultipleReportLayout,
      redirect: '/region/exam/multiple/report/basic/:id',
      children: [
        {
          path: '/region/exam/multiple/report/basic/:id',
          component: ExamMultipleReportBasic,
          name: 'exam-multiple-basic',
          meta: { parentPath: '/region/exam/single' }
        },
        {
          path: '/region/exam/multiple/report/level/:id',
          component: CityExamMultipleReportSchoolLevel,
          name: 'exam-multiple-level',
          meta: { parentPath: '/region/exam/single' }
        },
        {
          path: '/region/exam/multiple/report/rank/:id',
          component: CityExamMultipleReportSchoolRank,
          name: 'exam-multiple-rank',
          meta: { parentPath: '/region/exam/single' }
        },
        {
          path: '/region/exam/multiple/report/comment/:id',
          component: ExamMultipleReportComment,
          name: 'exam-multiple-comment',
          meta: { parentPath: '/region/exam/single' }
        },
        {
          path: '/region/exam/multiple/report/ability/:id',
          component: ExamMultipleReportAbility,
          name: 'exam-multiple-ability',
          meta: { parentPath: '/region/exam/single' }
        },
        {
          path: '/region/exam/multiple/report/transcript/:id',
          component: ExamMultipleReportTranscript,
          name: 'exam-multiple-transcript',
          meta: { parentPath: '/region/exam/single' }
        }
      ]
    },
    {
      path: '/region/exam/marking',
      name: 'exam-wuhen',
      meta: { auth: 'Region-Exam-Wuhen', keepAlive: true },
      component: ExamMarking
    },
    {
      path: "/region/exam/marking/paperReview",
      name: "exam-marking-paperReview",
      meta: { auth: "Region-Exam-Wuhen" },
      component: ExamMarkingPaperReview
    },
    {
      path: '/region/exam/marking/setting/:id',
      meta: { auth: 'Region-Exam-Wuhen' },
      component: ExamMarkingSettingNew,
      name: 'exam-marking-setting'
    },
    {
      path: '/region/exam/marking/readPaper/:id',
      name: 'exam-marking-readPaper',
      meta: { auth: 'Region-Exam-Wuhen', hideHeader: 'hide-header' },
      component: ExamMarkingReadPaper
    },
    {
      path: '/region/exam/marking/checkPaper/:id',
      name: 'exam-marking-checkPaper',
      meta: { auth: 'Region-Exam-Wuhen' },
      component: ExamMarkingCheckPaper
    },
    {
      path: '/region/exam/marking/error',
      name: 'exam-marking-error',
      meta: { auth: 'Region-Exam-Wuhen' },
      component: ExamMarkingError
    },
    {
      path: '/region/exam/marking/readMonitor/:id',
      name: 'exam-marking-readMonitor',
      meta: { auth: 'Exam-Wuhen' },
      component: ExamMarkingReadMonitor
    },

    // 省级批阅监控（省级暂无批阅监控）
    {
      path: '/region/exam/marking/data/:id',
      name: 'exam-marking-data',
      meta: { auth: 'Region-Exam-Wuhen' },
      component: ExamMarkingData,
      redirect: '/region/exam/marking/data/progress/:id',
      children: [
        {
          path: '/region/exam/marking/data/progress/:id',
          name: 'exam-marking-data-progress',
          meta: { auth: 'Region-Exam-Wuhen' },
          component: ExamMarkingDataProgress
        }, {
          path: '/region/exam/marking/data/spread/:id',
          name: 'exam-marking-data-spread',
          meta: { auth: 'Region-Exam-Wuhen' },
          component: ExamMarkingDataSpread
        }, {
          path: '/region/exam/marking/data/monitor/:id',
          name: 'exam-marking-data-monitor',
          meta: { auth: 'Region-Exam-Wuhen' },
          component: ExamMarkingDataMonitor
        }, {
          path: '/region/exam/marking/data/quality/:id',
          name: 'exam-marking-data-quality',
          meta: { auth: 'Region-Exam-Wuhen' },
          component: ExamMarkingDataQuality
        }
      ]
    },
    // 批阅监控---区域
    {
      path: '/region/exam/marking/data-region/:id',
      name: 'exam-marking-data-region-progress',
      meta: { auth: 'Region-Exam-Wuhen', parentPath: '/region/exam/single' },
      component: ExamMarkingDataRegionProgress
    },
    // 单科报告
    {
      path: '/region/exam/single/report',
      component: ExamSingleReportLayout,
      redirect: '/region/exam/single/report/school/basic/:id',
      children: [
        {
          path: '/region/exam/single/report/school/basic/:id',
          component: ExamSingleReportBasic,
          name: 'exam-report-basic'
        },

        {
          path: '/region/exam/single/report/school/comment/:id',
          component: ExamSingleReportComment,
          name: 'exam-report-comment'
        },
        {
          path: '/region/exam/single/report/school/rank/:id',
          component: ExamSingleReportRank,
          name: 'exam-report-rank'
        },
        {
          path: '/region/exam/single/report/school/ability/:id',
          component: ExamSingleReportAbility,
          name: 'exam-report-ability'
        },
        {
          path: '/region/exam/single/report/school/transcript/:id',
          component: ExamSingleReportTranscript,
          name: 'exam-report-transcript'
        },
        {
          path: '/region/exam/single/report/school/custom/:id',
          component: ExamSingleReportCustomLayout,
          redirect: '/region/exam/single/report/school/custom/:id/customGroup',
          children: [
            {
              path: '/region/exam/single/report/school/custom/:id/customGroup',
              component: ExamSingleReportCustomGroup,
              name: 'exam-report-custom-customGroup'
            },
            {
              path: '/region/exam/single/report/school/custom/:id/customContrast',
              component: ExamSingleReportCustomContrast,
              name: 'exam-report-custom-customContrast'
            },
            {
              path: '/region/exam/single/report/school/custom/:id/customKnowModel',
              component: ExamSingleReportCustomKnowModel,
              name: 'exam-report-custom-customKnowModel'
            }
          ]
        },
        {
          path: '/region/exam/single/report/class/basic/:id',
          component: ExamSingleReportClassBasic,
          name: 'exam-report-class-basic'
        },
        {
          path: '/region/exam/single/report/class/comment/:id',
          component: ExamSingleReportClassComment,
          name: 'exam-report-class-comment'
        },
        {
          path: '/region/exam/single/report/area/basic/:id',
          component: ExamSingleReportAreaBasic,
          name: 'exam-report-area-basic'
        },
        {
          path: '/region/exam/single/report/area/comment/:id',
          component: ExamSingleReportAreaComment,
          name: 'exam-report-area-comment'
        },
        {
          path: '/region/exam/single/report/area/rank/:id',
          component: ExamSingleReportRank,
          name: 'exam-report-area-rank'
        },
        {
          path: '/region/exam/single/report/area/ability/:id',
          component: ExamSingleReportAreaAbility,
          name: 'exam-report-area-ability'
        },
        {
          path: '/region/exam/single/report/area/transcript/:id',
          component: ExamSingleReportAreaTranscript,
          name: 'exam-report-area-transcript'
        },
        {
          path: '/region/exam/single/report/school/city_basic/:id',
          component: ExamSingleReportBasicCity,
          name: 'exam-report-basic-city'
        },
        {
          path: '/region/exam/single/report/school/city_comment/:id',
          component: ExamSingleReportCommentCity,
          name: 'exam-report-comment-city'
        },
        {
          path: '/region/exam/single/report/school/city_rank/:id',
          component: ExamSingleReportRank,
          name: 'exam-report-area-rank'
        },
        {
          path: '/region/exam/single/report/school/paper_quality/:id',
          component: ExamSingleReportPaperQuality,
          name: 'exam-report-paper-quality'
        },
        {
          path: '/region/exam/single/report/class/paper_quality/:id',
          component: ExamSingleReportPaperQuality,
          name: 'exam-report-class-paper-quality'
        },
        {
          path: '/region/exam/single/report/city_paper_quality/:id',
          component: ExamSingleReportPaperQuality,
          name: 'exam-report-city-paper-quality'
        },
        {
          path: '/region/exam/single/report/area/paper_quality/:id',
          component: ExamSingleReportPaperQuality,
          name: 'exam-report-area-paper-quality'
        }
      ]
    },
    {
      path: '/region/exam/single/report/school/comment/:id/:questionId/:type/edit',
      component: ExamSingleReportCommentEdit,
      name: 'exam-report-comment-edit'
    },

    ...v2,
  ]
}



// WEBPACK FOOTER //
// ./src/router/exam.js